<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
               
            </section>
            <!-- Main content -->
            <section class="content" >
                <el-dialog id="login" customClass="customWidth" :show-close="false" title="Login" :visible.sync="dialogVisible" size="tiny" visible="false" >
                    <div class="account-box">
                        <form role="form">
                            <div class="form-group"> <a href="#/forgotEmail" class="pull-right label-forgot">Forgot email?</a>
                                <label for="inputUsernameEmail" >Email</label>
                                <input type="text" id="inputUsernameEmail" v-model="email" class="form-control"> </div>
                            <div class="form-group"> <a href="#/forgotPassword" class="pull-right label-forgot">Forgot password?</a>
                                <label for="inputPassword">Password</label>
                                <input type="password" v-model="password" id="inputPassword" class="form-control"> </div>
                            <div class="checkbox pull-left">
                                <label>
                                    <input type="checkbox">Remember me</label>
                            </div>
                            <button class="btn btn btn-primary pull-right" type="submit" v-on:click="userLogin">Log In</button>
                        </form>
                        <a class="forgotLnk" href="#"></a>
                        <div class="or-box">
                            <center><span class="text-center login-with">Login or <b><a href="#/signup">Sign Up</a></b></span></center>
                       
                        </div>
                        <hr>
                        <div class="row-block">
                            <div class="row">
                                <div class="col-md-12 row-block"> <a href="#/signup" class="btn btn-primary btn-block">Create New Account</a> </div>
                                
                            </div>
                        </div>
                    </div>
                </el-dialog>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
        var Auth = require('../services/Authentication/auth')
        var to = require('await-to-js').default
const db = require('../services/database/database')
const cliStorage = require('../services/libraries/clientStoragelib')
const cliStorNames = cliStorage.clientStorageNames
const models = require('../services/database/models')
  const commonDB = require('../services/database/common')


  export default {
    data: function () {
      return {
        dialogVisible: false,
        showDialog: true,
        email : null,
        password:null,
        userToken: "",
        user:{
         firstName : null,
         lastName: null,
        phone : null,
        email: null,
        username: null,
        password: null,
        confirmPassword: null,
        city: null,
        zipcode: null,
        state: null,
        userID : null},
      }
    },
    mounted(){
      // if (this.mobileAndTabletCheck()){
      //   console.log("width", document.getElementById("login"))
      //   document.getElementById("login").customClass = "customWidth"
      // }
    },
    methods: {
      mobileAndTabletCheck : function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  console.log("mobile", check)
  return check;
},
    //   handleClose: function (done) {
    //               this.showDialog = false
    //             this.$router.push('/')
    //     // this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
    //     //   confirmButtonText: 'OK',
    //     //   cancelButtonText: 'Cancel',
    //     //   type: 'warning'
    //     // })
    //   },
    goToVerification: function(){
        this.$router.push({name: 'verification', params: {user:this.user }})
    },
      userLogin: async function(){
          var email = this.email
          var password = this.password
          const userData = {
              email,
              password
          }
         let result,error;
         [error, result] = await to(Auth.SignInUser(userData))

         if (error){
        const errorMsg = error.response.data.error.message 
        this.$confirm("Unable to login. " + errorMsg,  'ERROR', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'})
        }

        else if (result){
            console.log("result", result)
            this.$store.commit("setUserAuthentication", true)
                  console.log("user authenticated", this.$store.state.isUserAuthenticated)

            this.$cookie.set(cliStorNames.USER_TOKEN.name,result.data.idToken)
            this.$cookie.set(cliStorNames.REFRESH_TOKEN.name,result.data.refreshToken)
            let userErr, userRes
          [userErr, userRes] = await to(Auth.getUser({ UID: result.data.idToken }));
          if (userErr) {
            console.log("getting user userErr", userErr.response);
          } else if (userRes) {
              console.log("userRes",userRes)
              //TODO: When phone verification is added, then we will need to pull from DB here
                            this.user.userID = result.data.idToken
                            this.user.email = email
                this.user.localId = result.data.localId
                this.userToken = result.data.idToken
              const emailVerified = userRes.data.users[0].emailVerified
              console.log("email", emailVerified)
              if(emailVerified === true){
                  console.log("true")
                  let res, err; 
                  [err, res]= await to(commonDB.getUserFromDB(this.userToken, this.user.localId))
                  if (err){
                      console.error(err)
                  }
                  else if(res)
                  {
                    console.log("gone to dashboard!")
                    //TODO: Check if store variables persists on refresh
                    //TODO: check if we need to store in cookies or in local storage
                                this.$store.commit("setUserFirstName", res.data.fields.firstName.stringValue)
            this.$store.commit("setUserLastName", res.data.fields.lastName.stringValue)
            localStorage.setItem(cliStorNames.FIRST_NAME.name,res.data.fields.firstName.stringValue )
            localStorage.setItem(cliStorNames.LAST_NAME.name,res.data.fields.lastName.stringValue )
             localStorage.setItem(cliStorNames.CITY.name,res.data.fields.city.stringValue )
            localStorage.setItem(cliStorNames.STATE.name,res.data.fields.state.stringValue )
             localStorage.setItem(cliStorNames.ZIPCODE.name,res.data.fields.zipcode.stringValue )
            localStorage.setItem(cliStorNames.PHONE.name,res.data.fields.phone.stringValue )
            this.$cookie.set(cliStorNames.USER_ID.name,res.data.fields.userId.stringValue )

                   this.$router.push({name: 'dashboard', params: {userDocument: res.data.fields }})

                  }

              }
              else if(!emailVerified || emailVerified ===false){
                  this.$confirm("This user is not verified. Please verify this account to have full access to our services.", 'User Verification', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Verify Email',
        type:'warning'}).then(this.goToVerification).then(function () {
    console.log("close screen.")
  }).catch(function (err) {
        console.log("canceled." + err)

  })
      
              }
  
          }
        }

        // response.then(result => {
        //         console.log(result)
        //     this.$router.push('/')
        // }).catch(error =>{
        //     console.log("unable to sign in user. ", error)
        // })

      }, 
     
    }
  }
</script>
<style>
@media (max-width:450px){
  
   .el-dialog.customWidth{
            width:90%;
            
        }
  
      
    }

   
    @media(min-width:450px){
      
    .el-dialog.customWidth{
            width:50%;
            
        }
      
    }

</style>




// WEBPACK FOOTER //
// Login.vue?d7670ad6